import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectLayoutComponent } from './layouts/project-layout/project-layout.component';
import {  MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from './shared/shared.module';
import { RouterModule } from '@angular/router';


const MATERIAL_MODULES = [
  CommonModule,
  MatIconModule,
  MatTableModule,
  MatButtonModule,
  SharedModule,
  RouterModule,
]
@NgModule({
  declarations: [
    ProjectLayoutComponent,

  ],
  imports: [...MATERIAL_MODULES  ],
  exports:[
      ...MATERIAL_MODULES,
      ]
})
export class CoreModule { }
